// extracted by mini-css-extract-plugin
export default {"course_card_container":"CourseCard_course_card_container__RBu61","img":"CourseCard_img__LVZ5p","details":"CourseCard_details__PXAF1","contbtn":"CourseCard_contbtn__rVPpz"};